import { render, staticRenderFns } from "./MeasureMenuTier.vue?vue&type=template&id=caf08ab4&"
import script from "./MeasureMenuTier.vue?vue&type=script&lang=js&"
export * from "./MeasureMenuTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports